import React, { Component } from "react";
import { Button, Form, Input, notification } from "antd";

import { subscribeToNews } from "../../../Services";
import { ShowNotification } from "../../../Helpers";
const FormItem = Form.Item;

class EmailSubscriptionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {}

  onFinish = (values) => {
    this.setState({ isProcessing: true });
    const { name, email } = values;

    const params = {
      mailing_list_name: "news feed list",
      email,
      name,
    };

    subscribeToNews(params)
      .then((response) => {
        if (response.data.success) {
          ShowNotification({
            type: "success",
            message: "Success!",
            description: "Email subscription successful!",
          });
          this.formRef.current.resetFields();
        } else {
          ShowNotification({
            type: "error",
            message: "Error!",
            description: response?.data?.errors[0].title,
          });
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  optionLabel = (label) => {
    return (
      <>
        <span className="lbl-text">{label}</span>{" "}
        <span className="lbl-optional"> {"(optional)"}</span>
      </>
    );
  };

  render() {
    const { isProcessing } = this.state;
    return (
      <div className="home-card text-left">
        <div className="heading font-size-18 text-left">
          Subscribe to weekly news
        </div>
        <Form
          className="mt-10"
          layout="vertical"
          onFinish={this.onFinish}
          autoComplete="off"
          requiredMark={false}
          ref={this.formRef}
        >
          <FormItem label={this.optionLabel("Name")} name="name">
            <Input />
          </FormItem>
          <FormItem
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "The is not a valid email!",
              },
              {
                required: true,
                message: "Please enter your email!",
              },
            ]}
          >
            <Input />
          </FormItem>
          <FormItem className="text-left mt-20">
            <Button type="primary" htmlType="submit" loading={isProcessing}>
              Subscribe
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default EmailSubscriptionCard;
